import type { Highlight } from '../types';

export function isOwnHighlight(h: Highlight): boolean {
    return h.detail?.isOwnNote ?? true;
}
